<template>
  <svg
    style="margin-right: 3px"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4565_103253)">
      <rect x="0.125977" width="20" height="20" rx="10" fill="#4D4D4D" />
      <path
        d="M2.6824 3.08984L8.49179 10.7129L2.64453 16.911H3.95991L9.07753 11.4837L13.213 16.911H17.6894L11.5543 8.85919L16.9951 3.08984H15.6797L10.966 8.08846L7.15874 3.08984H2.6824ZM4.61634 4.04149H6.67399L15.7554 15.9618H13.6978L4.61634 4.04149Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4565_103253">
        <rect x="0.125977" width="20" height="20" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
